import { Injectable } from '@angular/core';
import { get, forEach, isEqual, cloneDeep } from 'lodash';
import { getAllLeafPaths } from '@schoolbelle/common/object-change-tracker';

@Injectable({
  providedIn: 'root'
})
export class ChangeDescriptorService {
  private o: any;
  private n: any;
  inserts: { path: string; to: any }[];
  deletes: { path: string; from: any }[];
  updates: { path: string; from: any; to: any }[];
  constructor() {}

  /**
   *
   * @param o old object
   * @param n new object
   */
  load(o: Object, n: Object) {
    if (isEqual(o, this.o) && isEqual(n, this.n)) return;
    this.o = cloneDeep(o);
    this.n = cloneDeep(n);

    let newLeavePaths = getAllLeafPaths(n);
    let oldLeavePaths = getAllLeafPaths(o);
    let insertedPaths = [];
    let deletedPaths = [];
    let updatedPaths = [];

    newLeavePaths.forEach(path => {
      let v_from_origin = get(o, path),
        v_from_current = get(n, path);
      if (typeof v_from_origin === 'undefined') insertedPaths.push(path);
      else if (v_from_origin !== v_from_current) updatedPaths.push(path);
    });
    oldLeavePaths.forEach(path => {
      let v_from_current = get(n, path);
      if (typeof v_from_current === 'undefined') deletedPaths.push(path);
    });

    this.deletes = this.contractPaths(deletedPaths, n).map(path => {
      return { path: this.simplifyPath(path, o), from: get(o, path) };
    });
    this.inserts = this.contractPaths(insertedPaths, o).map(path => {
      return { path: this.simplifyPath(path, n), to: get(n, path) };
    });
    this.updates = this.contractPaths(updatedPaths).map(path => {
      return {
        path: this.simplifyPath(path, n),
        from: get(o, path),
        to: get(n, path)
      };
    });
  }
  private simplifyPath(path: string, data: Object = {}) {
    const questionPathRegex = /questions\.([^\.]+)/;
    const optionPathRegex = /options\.([^\.]+)/;
    let questionMatch, optionMatch;
    if ((questionMatch = path.match(questionPathRegex))) {
      let question = get(data, ['questions', questionMatch[1]]);
      if (!question) return path;
      path = path.replace(questionPathRegex, 'Q' + (question.priority + 1));
      if ((optionMatch = path.match(optionPathRegex))) {
        let option = get(data, [
          'questions',
          questionMatch[1],
          'options',
          optionMatch[1]
        ]);
        if (!option) return path;
        path = path.replace(optionPathRegex, 'O' + (option.priority + 1));
      }
    }
    return path;
  }
  private contractPaths(paths: string[], data: Object = {}) {
    let contractedPaths = [];
    paths.forEach(path => {
      let contracted = false;
      forEach(path.split('.'), (bit, index) => {
        if (index % 2 === 0) return;
        let subpath = path
          .split('.')
          .slice(0, index + 1)
          .join('.');
        if (
          paths.filter(path => path.match(subpath)).length > 1 &&
          !get(data, subpath)
        ) {
          if (!contractedPaths.includes(subpath)) contractedPaths.push(subpath);
          contracted = true;
          return false;
        }
      });
      if (!contracted && !contractedPaths.includes(path))
        contractedPaths.push(path);
    });
    return contractedPaths;
  }
}
